import { render, staticRenderFns } from "./SetCommunication.vue?vue&type=template&id=3469d9c0"
import script from "./SetCommunication.vue?vue&type=script&lang=js"
export * from "./SetCommunication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports